var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$root.token
    ? _c(
        "b-container",
        [
          _c("br"),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { cols: "2" } }, [_vm._v(" ")]),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "8" } }, [
                _c("h3", [_vm._v("Compare/Report Multiple Scoring Events")])
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "2" } },
                [
                  _vm._v("\n      Download full spreadsheet \n      "),
                  _vm.downloading
                    ? _c("font-awesome-icon", {
                        attrs: { icon: "spinner", size: "lg", spin: "" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.downloading
                    ? _c("font-awesome-icon", {
                        attrs: { icon: "file-download", size: "lg" },
                        on: {
                          click: function($event) {
                            _vm.multiDownload()
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          !_vm.loading
            ? _c(
                "b-container",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { staticClass: "font-weight-bold" }, [
                        _vm._v("\n        Programme\n      ")
                      ]),
                      _vm._v(" "),
                      _c("b-col", { staticClass: "font-weight-bold" }, [
                        _vm._v("\n        Customer\n      ")
                      ]),
                      _vm._v(" "),
                      _c("b-col", { staticClass: "font-weight-bold" }, [
                        _vm._v("\n        Period and Year\n      ")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.scoringEvents, function(scoringEvent) {
                    return _c(
                      "b-row",
                      { key: scoringEvent.id },
                      [
                        _c("b-col", [
                          _vm._v(
                            "\n        " +
                              _vm._s(scoringEvent.programmeName) +
                              "\n      "
                          )
                        ]),
                        _vm._v(" "),
                        _c("b-col", [
                          _vm._v(
                            "\n        " +
                              _vm._s(scoringEvent.customerName) +
                              "\n      "
                          )
                        ]),
                        _vm._v(" "),
                        _c("b-col", [
                          _vm._v(
                            "\n        " +
                              _vm._s(scoringEvent.period) +
                              " " +
                              _vm._s(scoringEvent.year) +
                              "\n      "
                          )
                        ])
                      ],
                      1
                    )
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.loading
            ? _c("font-awesome-icon", {
                attrs: { icon: "spinner", size: "lg", spin: "" }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.loading
            ? _c("survey-analysis", {
                attrs: { "survey-runs": _vm.scoringEvents }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-074d3d98", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-074d3d98","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/MultiAnalyse.vue
// module id = null
// module chunks = 